import { FETCH_SEARCH_LOCATION } from '../actions/SearchLocationAction';

const initialState = {
  userLocation: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_SEARCH_LOCATION:
      return {
        ...action.payload
      }
    default:
      return {
        ...state
      }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/SearchLocationReducer.js